import { useNodeRef } from './useNodeRef';
import { useVariable } from './useVariable';
export var useMouseHover = function useMouseHover(onMouseOver, onMouseOut, initialRef, disabled) {
  if (disabled === void 0) {
    disabled = false;
  }

  var handleMouseOver = useVariable(disabled ? null : onMouseOver);
  var handleMouseOut = useVariable(disabled ? null : onMouseOut);

  var _useNodeRef = useNodeRef(initialRef, function (node) {
    node.addEventListener('mouseover', function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return handleMouseOver.current == null ? void 0 : handleMouseOver.current.apply(handleMouseOver, args);
    });
    node.addEventListener('mouseout', function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return handleMouseOut.current == null ? void 0 : handleMouseOut.current.apply(handleMouseOut, args);
    });
  }),
      setRef = _useNodeRef[0],
      nodeRef = _useNodeRef[1];

  return {
    setRef: setRef,
    nodeRef: nodeRef
  };
};